import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "DocumentSubject" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 3 }

import { PropType } from "vue";
import { Document } from "@/types";
import InnInput from "@/components/ds/input/Input.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentSubject',
  props: {
    document: {
        type: Object as PropType<Document>,
        required: true,
    },
    editable: {
        type: Boolean,
        default: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.document.english)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _cache[1] || (_cache[1] = [
          _createElementVNode("b", null, "Subject:", -1)
        ])))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, _cache[2] || (_cache[2] = [
          _createElementVNode("b", null, "Betreft:", -1)
        ]))),
    (__props.editable)
      ? (_openBlock(), _createBlock(InnInput, {
          key: 2,
          modelValue: __props.document.title,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.document.title) = $event)),
          placeholder: "Onderwerp",
          compact: ""
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (!__props.editable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.document.title), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})